var map = {
	"./Default.json": [
		"4591",
		"chunk-2d0c124f"
	],
	"./HyperPay.json": [
		"0b45",
		"chunk-2d0ae929"
	],
	"./MasterCard.json": [
		"cc9f",
		"chunk-2d221ca3"
	],
	"./Noon.json": [
		"d515",
		"chunk-2d21e32b"
	],
	"./Urway.json": [
		"bdf6",
		"chunk-2d21b148"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f2a9";
module.exports = webpackAsyncContext;